export const permissions = [
    'Administrator',
    'Synchronizator',
    'Magazynier'
]

